module.exports = __webpack_public_path__ + "static/media/news-conway.90c69894.jpg";